import { render, staticRenderFns } from "./GameReportTable.vue?vue&type=template&id=2d33a20f&scoped=true&"
import script from "./GameReportTable.vue?vue&type=script&lang=js&"
export * from "./GameReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d33a20f",
  null
  
)

export default component.exports